export default {
    columns: {
        image: 'Bild',
        title: 'Title',
        date: 'Datum',
        author: 'Author'
    }
}
